export default {
    // host: 'http://localhost/wmes_v2/'
    host: 'https://erp.khandaymal.co/api/'
    // host: 'https://lightgoldenrodyellow-meerkat-157479.hostingersite.com/api/'
    // host: 'http://192.168.1.93/wmes_v2/'
}